import { ReportType } from "../../types/Report";

export const EMPTY_REPORT: ReportType = {
  _id: "",
  title: "",
  description: "",
};
